import React, { useState, useEffect } from 'react';

export default function SendEmail(props) {

    const [email, setEmail] = useState('');
    const [countryErrorMessage, setCountryErrorMessage] = useState('');
    const [emailErrorMessage, setEmailErrorMessage] = useState('');
    const [message, setMessage] = useState([]);
    const [loading, setLoading] = useState(false);
    const [honeypot, setHoneypot] = useState('');
    const [successMessage, setSuccessMessage] = useState('');

    // console.log(props);

    useEffect(() => {
        resetForm();
    }, []);

    const resetForm = () => {
        setEmail('');
        setCountryErrorMessage('');
        setEmailErrorMessage('');
        setMessage([]);
        setLoading(false);
        setHoneypot('');
        setSuccessMessage('');
    };

    const handleEmailChange = (evt) => {
        setEmail(evt.target.value);
    }

    useEffect(() => {
        if (props.countrySelected === true) {
            setCountryErrorMessage('');
        }
    }, [props.countrySelected]);

    const handleSubmit = (evt) => {
        evt.preventDefault();

        // Honeypot field has a value, likely a bot submission
        if (honeypot) {
            // Honeypot field has a value, likely a bot submission
            console.log('Bot submission detected');
            return;
        }

        let formIsValid = true;

        const validationFunctions = [
            () => {
                // Validate country
                if (props.country === '') {
                    setCountryErrorMessage('Please select a country');
                    return false;
                } else {
                    setCountryErrorMessage('');
                    return true;
                }
            },
            () => {
                // Validate and Sanitize email input
                const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                if (!emailRegex.test(email)) {
                    setEmailErrorMessage('Please enter a valid email address');
                    return false;
                } else {
                    setEmailErrorMessage('');
                    return true;
                }
            }
        ];

        // call each validation function in sequence
        validationFunctions.forEach((validationFn) => {
            if (!validationFn()) {
                formIsValid = false;
            }
        });

        if (formIsValid && !props.transferData.formAbuse) {

            setLoading(true);

            const data = {
                country: props.country,
                people: props.people,
                nights: props.nights,
                airfare: props.airfare,
                lodging: props.lodging,
                food: props.food,
                transportation: props.transportation,
                entertainment: props.entertainment,
                tips: props.tips,
                major: props.major,
                slush: props.slush,
                total: props.total,
                ischecked: props.isChecked,
                email: email,
            };

            // Debug
            //console.log("Site Url: ", props.siteUrl);
            //console.log("Plugin Url: ", props.pluginUrl);
            //console.log('Thank you page: ', props.thankYouPage);
            //console.log('isCheckedIn', props.isChecked);
            //console.log('MailChimpData: ', props.mailchimpData);

            // Common ajax url
            const url = '/wp-admin/admin-ajax.php';

            // Ajax Handle
            const action = 'handle_info';            
            const urlWithAction = `${url}?action=${action}`;

            // Date
            const requestData = {
                action: `${action}`,
                nonce: props.transferData.ajaxNonce,
                dat: data,
            };

            // Actual Function
            const sendEmailData = () => {
                fetch(urlWithAction, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(requestData) })
                    .then(response => {
                        if (!response.ok) {
                            throw new Error('Email request failed');
                        }
                        return response.text(); // Read the response as text
                    })
                    .then(data => {
                        try {
                            console.log('Email Successful');
                            setLoading(false);
                            // Call handleRedirect after successful email send
                            handleRedirect();
                        } catch (error) {
                            console.log('Invalid JSON:', error);
                        }
                    })
                    .catch(error => {
                        console.log('Email Error:', error);
                        setLoading(false);
                    });
            }

            sendEmailData();


            // Ajax Handle
            const mailchimp_action = 'subscribe_user';
            const mailchimp_urlWithAction = `${url}?action=${mailchimp_action}`;

            // Data
            const mailchimp_requestData = {
                action: `${mailchimp_action}`,
                email: email,
                nonce: props.transferData.ajaxNonce,
            };

            // Actual Function
            const subscribeUser = () => {
                fetch(mailchimp_urlWithAction, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(mailchimp_requestData) })
                    .then(response => {
                        if (!response.ok) {
                            throw new Error('Subscription request failed');
                        }
                        return response.text(); // Read the response as text
                    })
                    .then(data => {
                        try {
                            console.log('Subscription Successful');
                            setLoading(false);
                        } catch (error) {
                            console.log('Invalid JSON:', error);
                        }
                    })
                    .catch(error => {
                        console.log('Subscription Error:', error);
                        setLoading(false);
                    });
            }

            subscribeUser();

            // Function to handle the redirect
            const handleRedirect = () => {
                setLoading(false);
                console.log("HandleRedirect fired!");
                // Redirect to the thank you page if thankYouPageCustom is not empty
                if (props.transferData.thankYouPage) {
                    window.location.href = props.transferData.thankYouPage;
                } else {
                    // Show success message if no thank you page is configured
                    setSuccessMessage('Thank you for using our tool! You will soon receive an email with your options.');
                }
            };

        }
    };

    return (
        <form
            onSubmit={handleSubmit}
            className='lead-form'
        >
            {
                !props.transferData.formAbuse ?
                    <div className='input-container'>
                        <label
                            htmlFor='email'
                            className='flexed-section-v1'
                        >Email:</label>
                        <input
                            id="email"
                            type="email"
                            value={email}
                            // onFocus={resetEmailErrorMessage}
                            onChange={handleEmailChange}
                            className='input-email'
                        />
                        <input
                            type="text"
                            name="website"
                            value={honeypot}
                            onChange={e => setHoneypot(e.target.value)}
                            style={{ display: 'none' }}
                        />
                    </div> : ''
            }
            <div className='error-container'>
                {countryErrorMessage && <p>{countryErrorMessage}</p>}
                {emailErrorMessage && <p>{emailErrorMessage}</p>}
                {props.transferData.formAbuse && <p>{props.transferData.maxSubMsg}</p>}
            </div>
            {
                !props.transferData.formAbuse ?
                    <div className=''>
                        <button
                            type="submit"
                            className=''
                            disabled={props.transferData.formAbuse}
                        >Submit</button>
                    </div> : ''
            }
            <div className='response-container'>
                {loading && <div><div className='spinner'></div><p>Processing...</p></div>}
                {successMessage && <p className='success-message'>{successMessage}</p>}
                {message && <p>{message}</p>}
            </div>
        </form>
    )
}
